import React from 'react';
import {Text, Link} from '@fluentui/react';

export function Home() {
    return (
        <div>
            <Text block as='h1' variant='xLarge'>Welcome to the Admin Console.</Text>
           
        </div>
    );
}

Home.displayName = Home.name;
